<script>
import { Radar } from "vue-chartjs";

export default {
  extends: Radar,

props:{
    //   Headline: String,
          labels: {
      type: Array,
      default: null},
      dataset: {
      type: Array,
      default: null},
  },

  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: this.dataset,

        // [
        //   {
        //     label: "Alla",
        //     backgroundColor: "rgba(179,181,198,0.2)",
        //     borderColor: "rgba(179,181,198,1)",
        //     pointBackgroundColor: "rgba(179,181,198,1)",
        //     pointBorderColor: "#fff",
        //     pointHoverBackgroundColor: "#fff",
        //     pointHoverBorderColor: "rgba(179,181,198,1)",
        //     data: [2, 4, -2,0,-4, 2]
        //   },
          // {
          //   label: "Snitt",
          //   backgroundColor: "rgba(255,99,132,0.2)",
          //   borderColor: "rgba(255,99,132,1)",
          //   pointBackgroundColor: "rgba(255,99,132,1)",
          //   pointBorderColor: "#fff",
          //   pointHoverBackgroundColor: "#fff",
          //   pointHoverBorderColor: "rgba(255,99,132,1)",
          //   data: [1,2,3,1,4,4]
          //   }
          // ,
          // {
          //   label: "Median",
          //   backgroundColor: "rgba(255,99,132,0.2)",
          //   borderColor: "green darken 1",
          //   pointBackgroundColor: "rgba(255,99,132,1)",
          //   pointBorderColor: "#fff",
          //   pointHoverBackgroundColor: "#fff",
          //   pointHoverBorderColor: "rgba(255,99,132,1)",
          //   data: [2, -5,3,-2, 3, 1]
          // }
        // ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  }
};
</script>